import { render, staticRenderFns } from "./homePart2.vue?vue&type=template&id=d56dd5b8&scoped=true&"
import script from "./homePart2.vue?vue&type=script&lang=js&"
export * from "./homePart2.vue?vue&type=script&lang=js&"
import style0 from "./homePart2.vue?vue&type=style&index=0&id=d56dd5b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56dd5b8",
  null
  
)

export default component.exports